export default "__VITE_ASSET__97021940__"